export default "__VITE_ASSET__Ba8GaFoK__"